// extracted by mini-css-extract-plugin
module.exports = {"select":"styles-module__select___tw-06","search-input-sm":"styles-module__search-input-sm___r6QVU"};